import { useEffect } from 'react';

/**
 * Listen for the Escape key and invoke `onClose` when pressed.
 * Use in modal/drawer components so Esc dismisses them — standard
 * keyboard UX expectation. Pass `enabled` false to noop (e.g., disable
 * while a confirm dialog inside the modal is open).
 *
 * Listener attaches on mount, detaches on unmount. Safe to use with
 * conditionally-rendered modals — render the modal only when open and
 * mount/unmount handles the lifecycle.
 */
export function useEscapeKey(onClose: () => void, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    function handler(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.stopPropagation();
        onClose();
      }
    }
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose, enabled]);
}
